<div id="drug-page-grid-controls">
  <div class="drug-page-grid-controls-dropdown">
    <div class="grid-control">
      <div nz-col class="line-item-search" style="width: 176px">
        <label class="filter-label">Line Items</label>
        <div class="ticker-search-wrapper">
          <app-pharma-analyst-tab-lineitem-search></app-pharma-analyst-tab-lineitem-search>
        </div>
      </div>
    </div>
    <span class="grid-control">
      <va-period-filter
        [periodData]="defaultPeriodObj"
        [filterWidthVariation]="3"
        [periodMinMax]="periodMinMax"
        (onApply)="periodSettingsChange($event)"
      ></va-period-filter>
    </span>
    <div class="grid-control currency-filter" style="width: 78px">
      <va-currency-select
        size="small"
        selectWidth="78"
        labelPlacement="top"
        [bottomBorderView]="true"
        [selectedCurrency]="selectedCurrency"
        [disabled]="currencyDisabled"
        [apiEP]="apiEP"
        apiUrl="/api/get_available_currencies"
        (onChange)="onCurrencyChange($event)"
      >
      </va-currency-select>
    </div>
    <div class="grid-control">
      <app-drug-distribution-data-revision-dropdown
        singleSelect="true"
        [dataView]="dataView"
        (saveDataView)="updateDataView($event)"
      >
      </app-drug-distribution-data-revision-dropdown>
    </div>
  </div>
  <div class="grid-control-reset-button">
    <va-button btnType="outline" size="small" (click)="handleOnReset()"
      >Reset</va-button
    >
  </div>
</div>
